import React, { Fragment } from "react";
import { Route, Routes } from "react-router-dom";

import SideBar from "./components/SideBar";
import Channelbar from "./components/ChannelBar";
import ContentContainer from "./components/ContentContainer";

function App() {
  return (
    <div className="flex">
      <SideBar />
      <Routes>
        <Route
          path="/"
          element={
            <Fragment>
              <span className="ml-16"></span>
              <ContentContainer pagename="Homepage" />
            </Fragment>
          }
        />
        <Route
          path="/about"
          element={
            <Fragment>
              <Channelbar content="about" />
              <ContentContainer pagename="About" />
            </Fragment>
          }
        />
        <Route
          path="/work"
          element={
            <Fragment>
              <span className="ml-16"></span>
              <ContentContainer pagename="Work Experience" />
            </Fragment>
          }
        />
        <Route
          path="/education"
          element={
            <Fragment>
              <Channelbar content="education" />
              <ContentContainer pagename="Education" />
            </Fragment>
          }
        />
        <Route
          path="/skills"
          element={
            <Fragment>
              <Channelbar content="skills" />
              <ContentContainer pagename="Skills" />
            </Fragment>
          }
        />
        <Route
          path="/portfolio"
          element={
            <Fragment>
              <Channelbar content="portfolio" />
              <ContentContainer pagename="Some of my previous work" />
            </Fragment>
          }
        />
        <Route
          path="/socials"
          element={
            <Fragment>
              <span className="ml-16"></span>
              <ContentContainer pagename="Get in touch" />
            </Fragment>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
